import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { getProducts } from '../../redux/actions/productActions';
import { Link } from 'react-router-dom';

const Search = () => {
  const dispatch=useDispatch();
  const[searchText,setSearchText]=useState('');
  const[searchResults,setSearchResults]=useState(false);
  const {products}=useSelector(state=>state.getProducts);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch])
  useEffect(() => {
    if(searchText){
      setSearchResults(true);
    }
  }, [searchText])

  return (
    <>
        <div className='bg-white h-[30px] rounded-lg w-[200px] p-[6px] flex items-center md:w-[300px] border-2 border-[#d64089]'>
            <SearchIcon style={{color:'#d64089'}}/>
            <input type="text" className='outline-none w-[150px] md:w-[250px]' onChange={(e)=>setSearchText(e.target.value)} placeholder='Search products..'/>

            {
              searchText &&
              <div className='absolute top-[60px] bg-white w-[190px] px-[6px] rounded-b-md md:w-[285px]'>
                  {
                    products.filter(product=>product.title.longTitle.toLowerCase().includes(searchText.toLowerCase())).map(product=>(
                      <div hidden={!searchResults} className='py-[8px] px-[4px] hover:bg-slate-200' onClick={()=>{setSearchResults(false)}}>
                        <Link to={`/product/${product.id}`}>
                          <div>
                            {product.title.shortTitle}
                          </div>
                        </Link>
                        <hr />
                      </div>
                    ))
                  }
              </div>
            }
        </div>
    </>
  )
}

export default Search
